import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSidebar } from '../../../contexts/SidebarContext';
import { Button, IconButton, Tooltip, useMediaQuery, useTheme, Paper, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import RefreshIcon from '@material-ui/icons/Refresh';
import FlightIcon from '@material-ui/icons/Flight';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import DownloadXLSAssetDetail from '../../DownloadXLSAssetDetail';
import DeletePopUp from '../DeletePopUp';
import { smbcInstance } from '../index';
import { downloadFileType, checkApiStatus } from '../../../utils';
import { assetType, moduleName } from '../../../constants';
import { globalExportService, globalGetService } from '../../../utils/globalApiServices';
import { trackActivity } from '../../../utils/mixpanel';
import config from '../../../config';
import PageLoader from '../PageLoader';
import { getAllAssetListAc } from '../../actionCreators';

const SubDetails = ({ title, slug, match, onRefresh, permissionCheck, masterExport, module, allAssets, getAllAssetListFn }) => {
	const sidebarOpen = useSidebar();
	const history = useHistory();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
	const isTab = useMediaQuery(theme.breakpoints.down('sm'));
	const { enqueueSnackbar } = useSnackbar();
	const [loading, setLoading] = useState(false);
	const [archiveModal, setArchiveModal] = useState(false);

	const isArchived = window?.location?.search === '?archived-assets';
	const techSpecUrl = `${config.domain.subDomian}technical-specification/${assetType[match?.params?.assetType]}/${slug}`;

	useEffect(() => {
		if (!allAssets.length) {
			getAllAssetListFn();
		}
	}, []);

	const selectedAsset = allAssets.find(a => a?.slug === slug && a?.asset_type == match?.params?.assetType) || null;

	const changeAssetSwitcher = (value) => {
		if (!value) return;
		const assetFound = allAssets.find(a => a?.slug === value?.slug);
		setLoading(true);
		const url = module
			? `camo/asset/${value?.id}/${value?.asset_type}/view/?module=${module}`
			: `camo/asset/${value?.id}/${value?.asset_type}/view/`;
		globalGetService(url).then(response => {
			setLoading(false);
			if (checkApiStatus(response)) {
				const id = response?.data?.data?.id;
				const targetPath = module
					? `/${id}/${assetFound?.asset_type}/${moduleName[module]}/list`
					: `/${id}/${assetFound?.asset_type}/tech_spec/list`;
				history.push(targetPath);
				setTimeout(() => { window.location.reload(false); }, 500);
			}
		});

	};

	const exportMasterApi = (queryParams) => {
		const date = new Date();
		const todayeDate = moment(String(date)).format("DD-MM-YYYY");
		const { asset, assetType: assetTypeParam } = match?.params;
		setLoading(true);
		globalExportService(`/camo/smbc_master_excel/${asset}/${assetTypeParam}/export/`)
			.then((response) => {
				setLoading(false);
				if (checkApiStatus(response)) {
					downloadFileType(response.data, `Master_Export_${todayeDate}`, queryParams.download);
					enqueueSnackbar("Master Export Download Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
					trackActivity("Camo - Master Export Downloaded Successfully", { page_title: "Via Engine Module" });
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			});
	};

	const onArchiveAsset = () => {
		setLoading(true);
		globalGetService(`console/archive-asset/${assetType[match?.params?.assetType]}/${slug}/true/`)
			.then(response => {
				setLoading(false);
				if (checkApiStatus(response)) {
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
					window.location.replace("/assets-listing");
				} else {
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
				}
			});
	};

	const headingStyle = {
		color: '#bd10e0',
		margin: '4px 0',
		fontSize: isMobile || isTab ? '14px' : '16px',
		whiteSpace: 'nowrap',
		fontFamily: 'Conv_IBMPlexSans-Regular',
	};

	return (
		<Paper elevation={1} square style={{ padding: '5px 10px', marginBottom: '10px', background: '#fbfbfb', overflow: 'hidden' }}>
			<ul style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', margin: 0, padding: 0, listStyle: 'none', width: '100%' }}>
				<li style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0, flexShrink: 1, overflow: 'hidden' }}>
					{match?.params?.assetType != 1 && (
						<div style={{ minWidth: '300px', maxWidth: '550px', marginRight: 8 }}>
							<Autocomplete
								options={allAssets || []}
								disabled={!slug}
								getOptionLabel={(option) => option?.unique_name || ''}
								value={selectedAsset}
								onChange={(e, value) => value ? changeAssetSwitcher(value) : e.preventDefault()}
								renderInput={params => (
									<TextField
										{...params}
										margin="none"
										variant="outlined"
										size="small"
										fullWidth
										InputLabelProps={{ shrink: true }}
										disabled={!slug}
									/>
								)}
							/>
						</div>
					)}
					{!sidebarOpen && <h3 style={{ ...headingStyle, overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</h3>}

					{!smbcInstance && (
						<a
							href={techSpecUrl}
							target="_blank"
							rel="noreferrer"
							style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', marginLeft: isMobile ? 8 : 24, flexShrink: 0 }}
						>
							<FlightIcon fontSize="small" color="primary" style={{ verticalAlign: 'middle' }} />
							<span style={{ ...headingStyle, marginLeft: 4 }}>Technical Specification</span>
						</a>
					)}
				</li>
				{isMobile && <li aria-hidden="true" style={{ width: '100%', height: 0, margin: 0, padding: 0 }} />}
				<li style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4, marginLeft: isMobile ? 0 : 'auto', marginRight: isMobile ? 0 : 14, marginTop: isMobile ? 6 : 0 }}>
					{masterExport ? <span className="export-list">
						<DownloadXLSAssetDetail
							files={{ title: 'MASTER EXPORT', extension: 'xlsx', key: '' }}
							exportReportFn={(file) => exportMasterApi({ download: file.extension })}
							style={{ color: '#bd10e0' }}
							variant='outlined'
							size="small"
						/>
					</span> : null}
					{permissionCheck && (
						<Tooltip title={isArchived || 'ARCHIVE ASSET'}>
							<span>
								<Button
									onClick={() => !isArchived && setArchiveModal(true)}
									color={isArchived ? 'default' : 'primary'}
									size="small"
									variant="outlined"
									style={{
										background: isArchived ? 'linear-gradient(269deg, #e1e1e1, #b3b3b3)' : undefined,
										fontSize: isMobile ? '10px' : '13px',
										padding: isMobile ? '2px 6px' : undefined,
										whiteSpace: 'nowrap',
										marginInline: '4px'
									}}
								>
									{isArchived || 'ARCHIVE ASSET'}
								</Button>
							</span>
						</Tooltip>
					)}
					<Tooltip title="Refresh">
						<IconButton style={{ padding: isMobile ? 4 : 5 }} color="primary" onClick={onRefresh}>
							<RefreshIcon fontSize={isMobile ? 'small' : 'default'} />
						</IconButton>
					</Tooltip>
				</li>
			</ul>
			{archiveModal && (
				<DeletePopUp
					title='Archive Asset'
					deleteRecordFn={onArchiveAsset}
					modal={true}
					content='Are you sure, you want to Archive?'
					toggleModalFn={() => setArchiveModal(false)}
					confirmText="ARCHIVE"
				/>
			)}
			{loading ? <PageLoader /> : null}
		</Paper>
	);
};

const mapStateToProps = (state) => ({
	allAssets: state.shareReducer.allAssets,
});

const mapDispatchToProps = (dispatch) => ({
	getAllAssetListFn: () => dispatch(getAllAssetListAc()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubDetails);
